module.exports = __webpack_public_path__ + "static/img/audition.c73dea40.png";